export const pageRoutes = {
  index: 'index.html',
  addons: 'addons.html',
  changePictures: 'change-pictures.html',
  combos: 'combos.html',
  faq: 'faq.html',
  privacyPolicy: 'privacy.html',
  registration: {
    showIdFirst: 'reg-id-first.html',
    normal: 'reg-user.html',
  },
  selectImages: 'select-images.html',
  selfies: 'selfies.html',
  shoppingCart: 'shopping-cart.html',
  selectImagesAddon: 'select-images-addon.html',
  shoot: 'shoot.html',
  aShoot: 'a-shoot.html',
};

export function appendQueryParams(search, params = {}) {
  const searchParams = new URLSearchParams(search);
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  return `?${decodeURIComponent(searchParams.toString())}`;
}

function redirectConstructor(routes) {
  return Object.keys(routes).reduce((acc, key) => {
    let value;
    if (typeof routes[key] === 'object') {
      value = redirectConstructor(routes[key]);
    } else {
      value = initRedirectTo(routes[key]);
    }
    return { ...acc, [key]: value };
  }, {});
}

export const redirectToPage = redirectConstructor(pageRoutes);

function initRedirectTo(path) {
  return async ({ rawSearch = '' } = {}) =>
    Promise.resolve().then(() => {
      window.location.href = `${path}${rawSearch}`;
    });
}
